import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-input border border-transparent bg-surface-muted px-4 py-2 text-base text-ink-primary transition-colors",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-ink-primary",
          "placeholder:text-ink-muted",
          "hover:bg-surface-subtle",
          "focus-visible:outline-none focus-visible:bg-surface-card focus-visible:border-accent-primary/30 focus-visible:ring-2 focus-visible:ring-accent-primary/20",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
